const site = {
    brand: 'Oracle Consults',
    founder: 'Oreste Twizeyimana',
    tagline: 'Founder-led backend consulting for operational software',
    location: 'Bydgoszcz, Poland',
    availability: 'Available remotely across Europe and internationally',
    calLink: 'https://cal.com/t.oreste?timezone=Europe%2FWarsaw',
    booking: {
      title: 'Book a discovery call',
      intro:
        'This short call is meant to reduce ambiguity early. We look at the real backend problem, the workflow it affects, and whether the next step should be an audit, a focused sprint, or a larger build.',
      highlights: [
        'We focus on the system pain point, not a generic sales script.',
        'You can bring a messy workflow, a slow backend, or an integration issue.',
        'If there is a fit, you leave with a clearer next step.'
      ],
      iframeTitle: 'Oracle Consults booking calendar',
      footerNote: 'Prefer the scheduler in a separate tab? Use the direct booking link instead.',
      directLinkLabel: 'Open scheduler in a new tab',
      stickyEyebrow: 'Need clarity fast?',
      stickyLabel: 'Book a discovery call',
      dismissLabel: 'Dismiss booking prompt'
    },
    seoTitle: 'Backend systems consulting',
    seoDescription:
      'Founder-led backend systems consulting for inventory, reservation, integration, reporting, and workflow-heavy software, backed by production .NET experience and systems thinking.'
  };

export default site;
